import { useParams } from 'react-router-dom';
import { useOrganisation } from './use-organisation';

export type UsePlatformAdminOrganisationOverrideReturn = ReturnType<
  typeof useOrganisation
> & { hasOverride: boolean; orgId: number };

export const usePlatformAdminOrganisationOverride =
  (): UsePlatformAdminOrganisationOverrideReturn => {
    const { orgId } = useParams<{ orgId: string }>();
    const overrideOrganisationId = parseInt(orgId ?? '-1');

    const result = useOrganisation(overrideOrganisationId);
    const hasOverride = result.data !== undefined;

    return { ...result, hasOverride, orgId: overrideOrganisationId };
  };
